import { render } from "./VTags.vue?vue&type=template&id=a012d6d2"
import script from "./VTags.vue?vue&type=script&lang=js"
export * from "./VTags.vue?vue&type=script&lang=js"

import "./VTags.vue?vue&type=style&index=0&id=a012d6d2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__